// Initial state 
const state = { 
    //ivestigationId: null
    //ivestigationId: null
};

// Update Data "mutations"
const mutations = {

    //updateViewDetails(state, value) {
    //    state.ivestigationId = value.ivestigationId
    //},

};
// Get data
const getters = {
//    getIsViewDetails: state => {
//        return {
//            ivestigationId: state.ivestigationId
//        }
//    },
};

export default {
    mutations,
    state,
    getters
};